import styled, { css } from 'styled-components'

import structure from '@/structure'
import { breakpoints, colors, fontSizes } from '@/styles'
import ChatNotification from '@/components/chat-notification'

const pricingLinkSpan = css`
  border: 1px solid ${colors.blue88};
  border-radius: 8px;
  background-color: ${colors.blue96};
  color: ${colors.blue32};
  font-size: 12px;
  padding: 4px 8px;
`

const DropdownButton = styled.button`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  width: calc(100% - 8px);
  text-decoration: none;
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 20px;
  margin: 0 4px;
  padding: 12px 10px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;

  :hover {
    background-color: ${colors.grey96};
  }
`

const PricingLink = styled.a`
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  text-decoration: none;
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 20px;
  margin: 0;
  padding: 12px 10px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;

  :hover {
    background-color: ${colors.grey96};
  }

  > span {
    ${pricingLinkSpan}
  }
`

const SidebarButtonMobile = styled.button`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-decoration: none;
  color: ${colors.regular};
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  padding: 15px 4px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;

  ${props =>
    props.hasLeftIcon &&
    `
      justify-content: flex-start;
      gap: 15px;
  `}
`

const PricingLinkMobile = styled.a`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  width: 100%;
  text-decoration: none;
  color: ${colors.regular};
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  padding: 15px 4px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  gap: 8px;

  > span {
    ${pricingLinkSpan}
  }
`

const SidebarHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 16px 0 8px;
  height: ${structure.header.height}px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    height: ${structure.header.heightMobile}px;
  }

  ${props =>
    props.hasLogo &&
    `
    padding: 0 16px;
  `}
`

const SidebarLabelMobile = styled.p`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-decoration: none;
  color: rgba(35, 37, 38, 0.5);
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin: 15px 4px 8px;
  text-decoration: none;
`

const DropdownLabel = styled.p`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-decoration: none;
  color: rgba(35, 37, 38, 0.5);
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin: 0;
  padding: 10px;
  text-decoration: none;
`

const SubMenuTitle = styled.p`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${colors.grey08};
  text-decoration: none;
  margin: 0 10px 0 0;
`

const CloseButton = styled.button`
  background: none;
  margin: 0;
  padding: 0;

  > svg {
    width: 40px;
    height: 40px;
  }
`

const StyledChatNotification = styled(ChatNotification)`
  width: 0px;
  height: 0px;
`

export {
  DropdownButton,
  PricingLink,
  PricingLinkMobile,
  SidebarButtonMobile,
  SidebarHeader,
  SidebarLabelMobile,
  DropdownLabel,
  SubMenuTitle,
  CloseButton,
  StyledChatNotification
}
